import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { UpdateCommentPayload } from 'sling-sdk/src/newsfeed/types/apiTypes';

import { useNewsfeedMappers } from '@web/newsfeed/hooks/useNewsfeedMappers';
import { useArticleCommentsQueryCache } from '@web/newsfeed/Article/ArticleComments/hooks/useArticleCommentsQueryCache';

export const useEditComment = () => {
  const { editComment } = useArticleCommentsQueryCache();
  const { newsfeedComments } = useSlingApi();
  const { mapAPIArticleCommentToUI } = useNewsfeedMappers();

  const mutation = useMutation({
    mutationFn: async (payload: UpdateCommentPayload) => {
      const result = await newsfeedComments.update(payload);
      return mapAPIArticleCommentToUI(result.data);
    },
    onSuccess: (payload) => {
      editComment(payload);
    },
  });

  return mutation;
};
